export const RewardTracks = {
	RewardWithdrawBtnClick: "RewardWithdrawBtnClick", // 返现任务-提现按钮点击
	RewardCalcMemberChangeClick: "RewardCalcMemberChangeClick", // 返现任务-奖励计算-切换订阅人数
	RewardCalcPlanChangeClick: "RewardCalcPlanChangeClick", // 返现任务-奖励计算-切换订阅版本
	RewardCalcCycleChangeClick: "RewardCalcCycleChangeClick", // 返现任务-奖励计算-切换订阅周期
	RewardCopyLinkBtnClick: "RewardCopyLinkBtnClick", // 返现任务-复制推荐链接

	RewardJoinLinkedInCommunityBtnClick: "RewardJoinLinkedInCommunityBtnClick", // 积分任务-LinkedIn关注-按钮点击
	RewardShareLinkedInPostBtnClick: "RewardShareLinkedInPostBtnClick", // 积分任务-分享LinkedIn帖子-按钮点击
	RewardInstallExtensionBtnClick: "RewardInstallExtensionBtnClick", // 积分任务-安装插件-按钮点击
	RewardWriteReviewBtnClick: "RewardWriteReviewBtnClick", // 积分任务-写Chrome评论-按钮点击
	RewardWriteRedPostBtnClick: "RewardWriteRedPostBtnClick", // 积分任务-小红书发帖-按钮点击
	RewardFollowRedBtnClick: "RewardFollowRedBtnClick", // 积分任务-关注小红书-按钮点击

	RewardWriteRedPostPopupShow: "RewardWriteRedPostPopupShow", // 积分任务-小红书发帖-规则说明弹窗展示
	RewardWriteRedPostPopupClose: "RewardWriteRedPostPopupClose", // 积分任务-小红书发帖-规则说明弹窗关闭
	RewardWriteRedPostPopupBtnClick: "RewardWriteRedPostPopupBtnClick", // 积分任务-小红书发帖-规则说明弹窗按钮点击
	RewardWriteRedPostPopupDownloadBtnClick:
		"RewardWriteRedPostPopupDownloadBtnClick", // 积分任务-小红书发帖-规则说明弹窗下载海报
	RewardWriteRedPostPopupCopyBtnClick: "RewardWriteRedPostPopupCopyBtnClick", // 积分任务-小红书发帖-规则说明弹窗复制文案
	RewardWriteRedPostPopupGoLeadContactAccBtnClick:
		"RewardWriteRedPostPopupGoLeadContactAccBtnClick", // 积分任务-小红书发帖-规则说明弹窗点击前往LeadContact官方账号

	RewardFollowRedPopupShow: "RewardFollowRedPopupShow", // 积分任务-关注小红书-规则说明弹窗展示
	RewardFollowRedPopupClose: "RewardFollowRedPopupClose", // 积分任务-关注小红书-规则说明弹窗关闭
	RewardFollowRedPopupBtnClick: "RewardFollowRedPopupBtnClick", // 积分任务-关注小红书-弹窗点击前往网页版
} as const;